<template>
    <div id="phoneListBody" class="phone-list__body active">
        <div class="phone-list__row" v-for="item in items">
            <div class="phone-list__cell h3">{{ item.District }}</div>
            <div class="phone-list__cell h3">{{ item.WorkingTime }}</div>
            <div class="phone-list__cell h3 _phone">{{ item.Phone }}</div>
        </div>       
    </div>
</template>
<script>
    export default {
        props: {
            items: Object
        }
    }
</script>


// WEBPACK FOOTER //
// Scripts/app/FooterContactInfo/PhoneList.vue